import CourseContentGridSection from "./CourseContentGridSection";

const coreValues = [
  {
    title: "品質",
    description: "學生透過由我們的職業導師和專業專家評估的市場開發項目、來獲得技術知識、解決問題的能力和編碼質量。\n",
  },
  {
    title: "課程實用性",
    description:
      "教授市場上實用編碼知識，學生透過市場開發項目，以展示他們的能力、持續和專業。我們的團隊仔細評估學生們的表現，並為進入行業奠定了堅實的基礎。\n",
  },
  {
    title: "職業推助",
    description:
      "TFA 擁有多年長期IT公司合作顆伴，了解市場需求，提供清晰IT 職業路向.  學生將接受全面的培訓，包括了解自己、定制簡歷、現場面試，了解他們的個性、溝通和技術能力，以確保他們適合併能“言行一致，感受到同行power\n",
  },
];

const courseFeatures = [
  {
    title: "實踐學習",
    description: "課程圍繞市場開發項目。您只需要遵循並添加您自己的想法和內容，為您的作品集和簡歷構建一個很好的商業項目！",
  },
  {
    title: "課程靈活性",
    description: "以港幣 9,000 元或以上的價格選修一門課程，或選修所有課程可享額外特別折扣！",
  },
  {
    title: "隨時幫助",
    description: "如果您遇到困難，將您的問題發布給講師。我們隨時為您提供幫助！我們希望確保您真正理解 並可以實際應用到商業項目中！",
  },
];

export default function FullTimeCourseExtraSections() {
  return (
    <>
      <CourseContentGridSection title="核心價值" items={coreValues} />
      <CourseContentGridSection title="課程特色" items={courseFeatures} />
    </>
  );
}


